import { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Container,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isBank = process.env.REACT_APP_APP_TYPE === 'Bank';

  const menuItems = [
    { text: 'Get Card', href: '#' },
    { text: 'About Us', href: '#' },
    { text: 'Contact Us', href: '#' },
    { text: 'Log in', href: '#' },
  ];

  return (
    <AppBar 
      position="static" 
      color="transparent" 
      elevation={0} 
      sx={{ 
        borderBottom: '1px solid #F2F2F2',
        backgroundColor: 'white',
        marginBottom: '20px',
        marginTop: '10px',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ height: 64, justifyContent: 'space-between' }}>
          {/* Mobile Menu Icon */}
          {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Logo */}
          {isBank ? (
            <Typography 
              variant="h5" 
              component="div" 
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                color: '#00019A',
                fontWeight: 700
              }}
            >
              <Box component="span">Comm</Box>
              <Box component="span" sx={{ fontStyle: 'italic' }}>Bank</Box>
            </Typography>
          ) : (
            <Typography variant="h5" component="div" sx={{ display: 'flex', alignItems: 'center' }}>
              <Box component="span" sx={{ fontWeight: 700 }}>First</Box>
              <Box component="span" sx={{ fontWeight: 500 }}>Street</Box>
            </Typography>
          )}

          {/* Desktop Menu */}
          {!isMobile && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              {menuItems.map((item) => (
                <Button
                  key={item.text}
                  color="inherit"
                  sx={{
                    fontSize: 16,
                    fontWeight: 500,
                    textTransform: 'none',
                    color: isBank ? '#00019A' : '#1A1A1A',
                  }}
                >
                  {item.text}
                </Button>
              ))}
              <Button
                variant="outlined"
                sx={{
                  borderRadius: '24px',
                  textTransform: 'none',
                  fontSize: 16,
                  fontWeight: 600,
                  px: 3,
                  py: 1,
                  borderColor: '#00019A',
                  color: '#00019A',
                  '&:hover': {
                    borderColor: '#000177',
                    backgroundColor: 'rgba(0, 1, 154, 0.04)'
                  }
                }}
              >
                Sign up
              </Button>
            </Box>
          )}

          {/* Mobile Menu Sign Up Button */}
          {isMobile && (
            <Button
              variant="outlined"
              sx={{
                borderRadius: 1,
                textTransform: 'none',
                fontSize: 16,
                fontWeight: 600,
                px: 2.5,
                py: 1,
              }}
            >
              Sign up
            </Button>
          )}

          {/* Mobile Menu */}
          {isMobile && (
            <Drawer
              anchor="top"
              open={isMobileMenuOpen}
              onClose={() => setIsMobileMenuOpen(false)}
              PaperProps={{
                sx: { top: 64 }
              }}
            >
              <List sx={{ pt: 3, pb: 3 }}>
                {menuItems.map((item) => (
                  <ListItem key={item.text} sx={{ py: 2 }}>
                    <ListItemText 
                      primary={item.text}
                      primaryTypographyProps={{
                        sx: { 
                          fontSize: 16, 
                          fontWeight: 500,
                          color: isBank ? '#00019A' : '#1A1A1A'
                        }
                      }}
                    />
                  </ListItem>
                ))}
                <ListItem sx={{ py: 2 }}>
                  <Button
                    fullWidth
                    variant="outlined"
                    sx={{
                      borderRadius: 1,
                      textTransform: 'none',
                      fontSize: 16,
                      fontWeight: 600,
                      py: 1,
                    }}
                  >
                    Sign up
                  </Button>
                </ListItem>
              </List>
            </Drawer>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
